export enum RiskThresholdType {
  Risk = 'Risk',
  RiskDensity = 'Risk Density'
}

export interface IThresholdConfigurationError {
  minMaxValueErrorRows: number[]
  minMaxDensityErrorRows: number[]
  continuityValueErrorRows: number[]
  continuityDensityErrorRows: number[]
}
